import { API_BASE_URL } from "@/config";
import { useToast } from "@/components/Toast/useToast";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "CIPCScore",
  data() {
    return {
      form: {
        registration_number: "",
        company_name: "",
      },
      error: "",
    };
  },
  setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
  methods: {
    format_registration_number(event) {
      let value = event.target.value.replace(/\D/g, "");
      if (value.length > 12) value = value.slice(0, 12);

      if (value.length > 4) {
        value = value.slice(0, 4) + "/" + value.slice(4);
      }
      if (value.length > 11) {
        value = value.slice(0, 11) + "/" + value.slice(11);
      }
      this.form.registration_number = value;
    },
    handle_submit() {
      if (!this.form.company_name) {
        let error_message = "Please enter a company name";
        $(".error-message").text(error_message).removeClass("d-none");
        setTimeout(() => {
          $(".error-message").text("").addClass("d-none");
        }, 3000);
        return;
      }

      if (!this.form.registration_number) {
        let error_message = "Please enter a company registration number";
        $(".error-message").text(error_message).removeClass("d-none");
        setTimeout(() => {
          $(".error-message").text("").addClass("d-none");
        }, 3000);
        return;
      }

      const string_fields = ["registration_number", "company_name"];
      for (const field of string_fields) {
        if (typeof this.form[field] !== "string" || !this.form[field].trim()) {
          let error_message = `Invalid input for ${field.replace(
            "_",
            " "
          )}. Please enter a valid string.`;
          $(".error-message").text(error_message).removeClass("d-none");
          setTimeout(() => {
            $(".error-message").text("").addClass("d-none");
          }, 3000);
          return;
        }
      }

      const TOKEN = localStorage.getItem("token");
      const CIPC_SCORE_API = `${API_BASE_URL}/verify_api/instant_verify_api/cipc_plus_score/`;

      this.error = "";

      $.ajax({
        url: CIPC_SCORE_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify({
          company_registration_number: this.form.registration_number,
          company_name: this.form.company_name,
        }),
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: (response) => {
          Swal.close();
          let status = response.status;
          let message = response.data;

          if (status === "success") {
            this.showSuccess(
              "Successful",
              "CIPC Plus Score retrieved successfully",
              3000
            );
            this.$emit("service_status_complete");
            this.form.registration_number = "";
            this.form.company_name = "";
          } else if (status === "error") {
            try {
              if (
                message &&
                message.includes(
                  "An error occurred on CIPC Verification: No record found"
                )
              ) {
                message = "Please enter a valid company registration number";
              }
            } catch (e) {
              message = "An error occurred";
            }
            $(".error-message").text(message).removeClass("d-none");
            setTimeout(() => {
              $(".error-message").text("").addClass("d-none");
            }, 3000);
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error verifying company";

          if (error.responseJSON) {
            if (error.responseJSON.message) {
              error_message = error.responseJSON.message;
            }
            $(".error-message").text(error_message).removeClass("d-none");
            setTimeout(() => {
              $(".error-message").text("").addClass("d-none");
            }, 3000);
          } else {
            $(".error-message").text(error_message).removeClass("d-none");
            setTimeout(() => {
              $(".error-message").text("").addClass("d-none");
            }, 3000);
          }
        },
      });
    },
  },
};
